

















































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import myTable from '../../../components/table/my-table.vue'
import ECharts from 'vue-echarts'
import walden from '../../../components/charts/themes/walden.json'
import {PatientOutCome,PatientOutComeDetail} from '../../../api/realTime'

@Component({
    components: {ECharts,myTable}
})
export default class extends AbpBase {
    created(){
        ECharts.registerTheme('ovilia-green', walden);
        this.getSelects()
        this.getData()
    }
    tipShow = true
    option = {}
    queryform = {
        tenantId:[],
        isTemp:null,
    }
    tenantOptions = []
    //获取下拉框
    async getSelects(){
        this.tenantOptions = (await GetTenantInfo({})).data
    }
    searchPopShow = false
    tabs:any = [
        {closable:false,key:0,name:'数据统计',year:null,},
    ]
    activeName = `数据统计`
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
        this.tabChange()
    }
    detail(p:any){
        console.log(p)
        let name;
        if(p.column.key === 'date'){
            name = p.row.date+'转归'
        }else{
            if(p.row.date =='合计' && this.activeName == '数据统计'){
                name = p.column.title+'转归'
            }else if(p.row.date !='合计' && this.activeName == '数据统计'){
                name = p.row.date + p.column.title+'转归'
            }else if(p.row.date !='合计' && this.activeName != '数据统计'){
                name = p.row.date + p.column.title+'转归'
            }else{
                name = this.activeName.substr(0,4) + p.column.title+'转归'
            }
        }
        let tab = this.tabs.find((item:any)=>{return item.name == name})
        if(tab){
            this.activeName = tab.name;
            this.tabChange()
            return false 
        }

        if(p.column.key === 'date'){
            this.tabs.push({
                closable:true,
                key:0,
                name:name,
                year:p.row.date.length == 4 ? p.row.date : p.row.date.split('-')[0],
                month:p.row.date.length == 4 ? 0 : p.row.date.split('-')[1],
            })
            this.activeName = name
            this.tabChange()
        }else{
            this.tabs.push({
                closable:true,
                key:0,
                name:name,
                type: p.column.title,
                year:p.row.date=='合计' && this.activeName == '数据统计' ? null : p.row.date.length == 2 ? this.activeName.substr(0,4) : p.row.date.length == 4 ? p.row.date : p.row.date.split('-')[0],
                month:p.row.date=='合计'? null : p.row.date.length == 4 ? null : p.row.date.split('-')[1],
            })
            this.activeName = name
            this.tabChange()
        }
    }
    ifTS = false
    tabChange(){
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        if(tab.type == undefined && !tab.month){
            this.getData()
            this.ifTS = false
        }else{
            this.ifTS = true
            this.getDetailData()
        }
    }
    list = []
    detailList = []
    columns = []
    detailColumns = []
    renderColumns(){
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.columns = [
            {
                title: active.year?active.year:'年份',
                key: 'date',
                width:150,
                render:(h:any,p:any)=> {
                    return p.row.date==='合计' ? h('span',p.row.date):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.date)
                },
            },
            {
                title: '腹透',
                key: 'pd',
                render:(h:any,p:any)=> {
                    return p.row.pd == 0 ? h('span',p.row.pd):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.pd)
                },
            },
            {
                title: '移植',
                key: 'transplant',
                render:(h:any,p:any)=> {
                    return p.row.transplant == 0 ? h('span',p.row.transplant):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.transplant)
                },
            },
            {
                title: '死亡',
                key: 'death',
                render:(h:any,p:any)=> {
                    return p.row.death == 0 ? h('span',p.row.death):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.death)
                },
            },
            {
                title: '血透',
                key: 'hd',
                render:(h:any,p:any)=> {
                    return p.row.hd == 0 ? h('span',p.row.hd):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.hd)
                },
            },
            {
                title: '失随访',
                key: 'lossFollowUp',
                render:(h:any,p:any)=> {
                    return p.row.lossFollowUp == 0 ? h('span',p.row.lossFollowUp):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.lossFollowUp)
                },
            },
            {
                title: '其他',
                key: 'other',
                render:(h:any,p:any)=> {
                    return p.row.other == 0 ? h('span',p.row.other):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.other)
                },
            },
            {
                title: '转回中心',
                key: 'transfer',
                render:(h:any,p:any)=> {
                    return p.row.transfer == 0 ? h('span',p.row.transfer):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.transfer)
                },
            },
            {
                title: '转出中心',
                key: 'transferOut',
                render:(h:any,p:any)=> {
                    return p.row.transferOut == 0 ? h('span',p.row.transferOut):h('span',{
                            style:{
                                color:'rgb(64, 158, 255)',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            on:{
                                'click':()=>{
                                    this.detail(p)
                                }
                            }
                        },p.row.transferOut)
                },
            },
            {
                title: '总共',
                key: 'count',
            },
        ]
    }
    renderDetailColumns(){
        this.columns = [
            {
                title:'名称',
                key:'reason',
            },
            {
                title:'数量',
                key:'quantity',
            },
            {
                title:'占比',
                key:'percent',
            },
        ]
        this.detailColumns = [
            {
                title:'患者姓名',
                key:'patientName',
            },
            {
                title:'时间',
                key:'date',
            },
            {
                title:'类别',
                key:'category',
            },
            {
                title:'原因',
                key:'reasons',
            }
        ]
    }
    async getData(){
        this.list = []
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.renderColumns()
        let data = {
            year:active.year,
            tenantIds:this.queryform.tenantId,
            isTemp:this.queryform.isTemp,
        }
        let res = await PatientOutCome(data)
        let total:any = {
            date:'合计',
            pd:0,
            transplant:0,
            death:0,
            hd:0,
            lossFollowUp:0,
            other:0,
            transfer:0,
            transferOut:0,
            count:0,
        }
        res.data.forEach(item => {
            total.pd += Number(item.pd)
            total.transplant += Number(item.transplant)
            total.death += Number(item.death)
            total.hd += Number(item.hd)
            total.lossFollowUp += Number(item.lossFollowUp)
            total.other += Number(item.other)
            total.transfer += Number(item.transfer)
            total.transferOut += Number(item.transferOut)
            total.count += Number(item.count)
        });
        for (const key in total) {
            if(Number(total[key]) !==0 && key!=='count' && key!=='date'){
                total[key] = total[key] + `(${((total[key]/total.count)*100).toFixed(2)}%)`
            }
        }
        this.list = [...res.data,total]
        this.renderCharts(res.data)
    }
    async getDetailData(){
        this.list = []
        this.detailList = []
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.renderDetailColumns()
        let data = {
            year:active.year,
            month:active.month,
            tenantIds:this.queryform.tenantId,
            isTemp:this.queryform.isTemp,
            type:active.type,
        }
        let res = await PatientOutComeDetail(data)
        let total:any = {
            reason:'合计',
            quantity:0,
            percent:'100%',
        }
        res.data.outComePercent.forEach(item => {
            total.quantity += Number(item.quantity)
        });
        this.list = [...res.data.outComePercent,total]
        this.detailList = res.data.outComeDetail
        this.renderDetailCharts(res.data.outComePercent)
    }
    renderCharts(data:any){
        let active = this.tabs.find((item:any)=>{return item.name == this.activeName})
        let xAxis = ["腹透", "移植", "死亡", "血透", "失访随", "其他", "转回中心", "转出中心"]
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            legend:{
                data:xAxis
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data:data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                },
            ],
            series: active.month?data.map((v:any)=>{
                return {
                    name:v.date,
                    type: 'bar',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data:this.getValue(xAxis,v),
                }
            }):xAxis.map((v:any)=>{
                return {
                    name:v,
                    type: 'bar',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data:this.getValue2(data,v),
                }
            })
        }
    }
    renderDetailCharts(data:any){
        this.option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            legend:{
                data:data.map((v:any)=>{return v.reason})
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            series: {
                type: 'pie',
                radius : '55%',
                center: ['50%', '50%'],
                label: {
                    normal: {
                        formatter: '{b}：{c}({d}%)',
                    }
                },
                data:data.map((v:any)=>{
                    return {
                        value:v.quantity,
                        name:v.reason,
                    }
                })
            } 
            
            
        }
    }
    getValue(xAxis:any,row:any){
        let list = [];
        xAxis.forEach(v => {
            this.columns.forEach((c:any)=>{
                if(v === c.title){
                    list.push(row[c.key])
                }
            })
            
        });
        return list
    }
    getValue2(data:any,v:any){
        let list = [];
        data.forEach(item => {
            this.columns.forEach((c:any)=>{
                if(v === c.title){
                    list.push(item[c.key])
                }
            })
        });
        return list
    }
    downxlsx(){
        let XLSX = this.$XLSX;
        var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
        let a = document.createElement('div')
        if(document.querySelector("#mytable2")){
            a.innerHTML = document.querySelector("#mytable2").outerHTML
        }else{
            a.innerHTML = document.querySelector("#mytable").outerHTML
        }
        a.innerHTML = a.innerHTML.replace(/详情/g, '');
        var wb = XLSX.utils.table_to_book(a,xlsxParam);//mytable为表格的id名
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        let filename = `${this.activeName}`+".xlsx"
        try {
            this.$FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            filename
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
}
